<header
	class="flex items-center justify-between gap-4 h-18 px-8 text-white shadow-primary z-2"
>
	<img
		draggable="false"
		class="h-6 w-auto"
		src="assets/images/wordmark-white.png"
	/>

	<button
		tuiButton
		type="button"
		appearance="primary"
		iconStart="@tui.log-out"
		(click)="onExit()"
	>
		{{ 'external.viewer.exit' | transloco }}
	</button>
</header>

<main class="flex-1 min-h-0 overflow-hidden flex flex-col">
	<router-outlet />
</main>
